<h2 class="sectionTitle">{{'FRONT_USER.WORKSPACE.MY_REQUESTS'| translate}}</h2>

<div class="services-filter">
  <div class="form-container">
    <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
    <div class="form-group">
      <label for="txtCreationDateFrom">{{ 'SHARED.DateFrom' | translate}}</label>
      <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" #input="bsDatepicker" [(ngModel)]="creationDateFrom"
      bsDatepicker [minDate]='null' [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
    </div>
    <div class="form-group">
      <label for="txtCreationDateTo">{{ 'SHARED.DateTo' | translate}}</label>
      <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" #input="bsDatepicker" [(ngModel)]="creationDateTo"
      bsDatepicker [minDate]='null' [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}">
    </div>
    <div class="form-group">
      <label for="dllServiceName">{{ 'SHARED.MYREQUESTS.ServiceName' | translate}}</label>
      <select class="form-control" id="dllServiceName" name="dllServiceName" [(ngModel)]="serviceId" (change)="changeService(serviceId, false)">
        <option value="" >--- {{'SHARED.AllServices' | translate}} ---</option>
        <option *ngFor="let service of myRequestsLookups?.Services" value="{{service.Id}}">
          {{currentLanguage == "Ar" ? service.NameAR : service.NameEN}}
        </option>
      </select>

    </div>
    <div class="form-group">
      <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
      <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="serviceStatus">
        <option value="" >--- {{'SHARED.AllStatuses' | translate}} ---</option>
        <option *ngFor="let status of myRequestsLookups?.Statuses" value="{{status.Id}}" >
          {{currentLanguage == "Ar" ? status.StatusAR : status.StatusEN}}
        </option>
      </select>
    </div>
    <!-- <div class="form-group">
      <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
      <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="serviceStatus">
          <option value="" >--- {{'SHARED.AllStatuses' | translate}} ---</option>
        <option *ngFor="let status of myRequestsStatuses" value="{{status.Id}}">
          {{currentLanguage == "Ar" ? status.StatusAR : status.StatusEN}}
        </option>
      </select>
    </div> -->

    <div class="form-group">
      <label for="txtRequestNumber">{{ 'SHARED.MYREQUESTS.RequestNumber' | translate}}</label>
      <input type="text" class="form-control" id="txtRequestNumber" name="txtRequestNumber" [(ngModel)]="requestNumber" />
    </div>
  </div>
  <div class="btns-holder text-center">
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadMyRequests()" value="{{ 'SHARED.Search' | translate}}" />
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetMyRequests()" value="{{ 'SHARED.ResetSearch' | translate}}" />
  </div>
  <div class="red" *ngIf="isFromGreaterThanTo">
    {{ 'SHARED.MYREQUESTS.DateFromGreaterThanDateTo' | translate}}
  </div>
</div>
<app-grid-view #MyRequests></app-grid-view>
